export const START_LOADING = 'START_LOADING'
export const END_LOADING = 'END_LOADING'
export const INCREMENT_PENDING_REQUESTS = 'INCREMENT_PENDING_REQUESTS'
export const DECREMENT_PENDING_REQUESTS = 'DECREMENT_PENDING_REQUESTS'
export const SET_ITEMS = 'SET_ITEMS'
export const SELECT = 'SELECT'
